import React, { useEffect } from "react";
import "style/ModalStyles.css";
const TermsModal = (props: any) => {
  useEffect(() => {
    document.body.style.cssText = `
          position: fixed; 
          top: -${window.scrollY}px;
          overflow-y: scroll;
          width: 100%;`;
    return () => {
      const scrollY = document.body.style.top;
      document.body.style.cssText = "";
      window.scrollTo(0, parseInt(scrollY || "0", 10) * -1);
    };
  }, []);

  return (
    <div className="modalBackground">
      <div className="modalContainer-terms">
        <h2 id="font-SCD4">
          {props.terms.kind === "A"
            ? "이용약관"
            : props.terms.kind === "C"
            ? "개인정보처리방침"
            : "회원 개인정보 수집 ・ 이용 동의서"}
        </h2>
        <div className="mtitleCloseBtn">
          <button
            onClick={() => {
              props.setTermsModalOpen(false);
            }}
          ></button>
          <br></br>
        </div>

        <div className="termsBody">
          {props.terms.contents &&
            props.terms.contents.split("\n").map((line: any, index: any) => {
              line = line.trim();
              return (
                <div key={index}>
                  {!isNaN(line[0]) ? (
                    <b> {line} </b>
                  ) : line[0] === "-" ? (
                    <span>&nbsp;{line}</span>
                  ) : line[0] === "∙" ? (
                    <span>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;{line}</span>
                  ) : (
                    line
                  )}
                  <br></br>
                </div>
              );
            })}
        </div>
        <div className="mfooter">
          <div
            className="btn-modal-right"
            style={
              props.footer ? { textAlign: "center" } : { textAlign: "right" }
            }
          >
            {props.footer === true ? (
              <button
                className="terms-confirm"
                onClick={() =>
                  props.termsModalCallback(false, props.terms.kind)
                }
                id="font-SCD6"
              >
                확인
              </button>
            ) : (
              <div>
                <button
                  className="terms-agree"
                  onClick={() =>
                    props.termsModalCallback(true, props.terms.kind)
                  }
                  id="font-SCD4"
                >
                  동의합니다
                </button>
                <button
                  className="terms-cancel"
                  onClick={() =>
                    props.termsModalCallback(false, props.terms.kind)
                  }
                  id="font-SCD4"
                >
                  취소
                </button>
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default TermsModal;
